var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.281.875c-.604 0-1.093.49-1.093 1.094V12.03c0 .604.49 1.094 1.093 1.094H8.72c.604 0 1.094-.49 1.094-1.094V7.437A2.19 2.19 0 0 0 7.624 5.25H6.531a1.094 1.094 0 0 1-1.093-1.094V3.063A2.19 2.19 0 0 0 3.25.874zM2.375 8.75a.437.437 0 0 1 .438-.437h4.374a.437.437 0 1 1 0 .874H2.814a.437.437 0 0 1-.438-.437m.438 1.313a.438.438 0 0 0 0 .874H5a.438.438 0 0 0 0-.874z",
    clipRule: "evenodd"
  })));
};
export default SvgNote;